import { Divider, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

/**
 * Shared component for Schedule of Values section
 * Used in CreateCommitmentsForm.jsx to reduce duplication
 */
export const ScheduleOfValuesSection = ({ children }) => (
  <>
    <Typography variant="h6" gutterBottom>
      Schedule of Values
    </Typography>
    <Divider sx={{ mb: 2 }} />
    <Grid container spacing={3} mb={2}>
      <Grid item xs={12}>
        {children}
      </Grid>
    </Grid>
  </>
);

ScheduleOfValuesSection.propTypes = {
  children: PropTypes.node.isRequired,
};
